// nominatim-client.js

// ======= Globale Basis-URL (einfach hier ändern) =======
export let NOMINATIM_BASE_URL = 'https://nominatim.cutvert.de';
// =======================================================

export class NominatimClient {
    constructor(opts = {}) {
        this.minDelayMs  = Number.isFinite(opts.minDelayMs) ? opts.minDelayMs : 1100;
        this._lastAt     = 0;
    }

    // --- Forward Search ---
    async search(query, opts = {}) {
        const params = typeof query === 'string' ? { q: query } : { ...query };
        params.format = params.format || 'jsonv2';
        if (!('addressdetails' in params)) params.addressdetails = 1;
        if (!('limit' in params)) params.limit = 10;
        return this._fetch('/search', params, opts);
    }

    // --- Reverse Lookup ---
    async reverse({ lat, lon, zoom = 18, params = {} }, opts = {}) {
        const q = { format: 'jsonv2', addressdetails: 1, lat, lon, zoom, ...params };
        return this._fetch('/reverse', q, opts);
    }

    // --- Lookup (optional) ---
    async lookup({ osm_ids, params = {} }, opts = {}) {
        const q = { format: 'jsonv2', osm_ids, ...params };
        return this._fetch('/lookup', q, opts);
    }

    // ---- intern ----
    async _waitForSlot() {
        const now = Date.now();
        const delta = now - this._lastAt;
        if (delta < this.minDelayMs) await new Promise(r => setTimeout(r, this.minDelayMs - delta));
        this._lastAt = Date.now();
    }

    async _fetch(path, params = {}, { acceptLanguage } = {}) {

        const base = NOMINATIM_BASE_URL.replace(/\/+$/, '');
        const url = new URL(base + path);
        for (const [k, v] of Object.entries(params)) {
            if (v != null) url.searchParams.set(k, String(v));
        }

        const headers = {};
        if (acceptLanguage) headers['Accept-Language'] = acceptLanguage;

        const res = await fetch(url.toString(), { headers });

        if (res.status === 429) {
            const retryAfter = parseInt(res.headers.get('Retry-After') || '1', 10);
            await new Promise(r => setTimeout(r, Math.max(1000, retryAfter * 1000)));
            return this._fetch(path, params, { acceptLanguage });
        }

        if (!res.ok) {
            const text = await res.text();
            throw new Error(`Nominatim ${res.status}: ${text.slice(0, 300)}`);
        }

        return res.json();
    }
}